module.exports = __webpack_public_path__ + "087dff099ce453a187ef9835fd6fd78b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanWebPro-Book.woff
// module id = 622
// module chunks = 0